import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { IScreen } from '../interfaces/IScreen';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';

@Injectable({
  providedIn: 'root'
})
export class RoleService extends RestCallService {
  constructor(
    public httpClient: HttpClient,
    public toastr: ToastrService,
    public notificationService: NotificationService,
    public translate: TranslateApplicationService
  ) {
    super(httpClient, 'JabilPTUApi', toastr, notificationService, translate);
  }

  public GetUserHasPermissionToScreen(screen)
  {
    let data = { screen }
    return this.post<IScreen[]>('Roles/GetUserHasPermissionToScreen', data);
  }

  public GetScreensByUsername()
  {
    return this.post<IScreen[]>('Roles/GetScreensByUsername');
  }
}
